// @ts-ignore
import { type ApiResult } from "@utils/httpClientCore";
import { gaApiCall } from "@utils/httpClientCsrf";
// @ts-ignore
import { hasProp, assert } from "@utils/assertion";
// @ts-ignore
import { DateTime } from "luxon";
// @ts-ignore
import { renderJsonWithNumbersAsBigint, parseJsonWithNumbersAsBigint, type ParserResult } from "@utils/json";
// @ts-ignore
import type * as schema from "@newgenerated/shared/schema";
import { serialize_OutboundLink } from "@newgenerated/shared/serializerDeserializer/OutboundLink";

export async function trackOutboundLinkClick(props: { body: schema.OutboundLink }): Promise<ApiResult> {
  const path = "/gaapi/act/olc";
  const response = await gaApiCall({
    path: path,
    method: "POST",
    requestBody: ((value) => {
      return serialize_OutboundLink(value);
    })(props.body),
  });
  if (response.kind == "error") {
    return response;
  }
  return { kind: "success" };
}
